
import { AppDocumentos } from '../../../core/models/appDocumentos.model';
import { AppDocumentosService } from '../../../core/services/appDocumentos.service';
import { AppA3DocDocument } from '../../../core/models/appA3DocDocument.model';
import { AppA3DocService } from '../../../core/services/appA3Doc.service';

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { EditFormBase } from '../../../core/helper/EditFormBase';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { Location } from '@angular/common';
import { PathRoutes } from '../../../core/configuration/pathRoutes';
import { AppUsuarioService } from '../../../core/services/appUsuarioService.service';
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';


@Component({
  selector: 'app-documentos-detail',
  templateUrl: './documentos-detail.component.html',
  styleUrls: ['./documentos-detail.component.scss'],
  providers: [AppDocumentosService, AppA3DocService, AppA3DocDocument, AppUsuarioService]
})
export class DocumentosDetailComponent extends EditFormBase<AppDocumentos, string> implements OnInit {

  // Propiedades del panel contenedor
  panelIcon = 'upload_file'; // font awesome
  panelIconTwo = 'person'; // font awesome
  panelTitle = 'Subir documento';
  panelTitleTwo = 'Editar documento';
  panelTitleThree = 'Empleados';
  panelDescription = 'Subir documento';
  panelDescriptionTwo = 'Editar documento';
  panelDescriptionThree = 'Empleados';
  sendButton = 'Subir';

  documentName: string = '';
  documentMimeType: string = '';
  documentData: string = '';
  modifiedBy: string = '';
  modifiedByData: { id: string, fullName: string } = { id: this._livesSession.AspNetUserId, fullName: `${this._session.User.Name} ${this._session.User.Surname}` };
  createdAt: Date;
  category: { docCategory1: string, name: string } = { docCategory1: '', name: '' }
  company: { company1: string, name: string } = { company1: '', name: '' }
  b64file: string = '';
  adminOrigin: { origin1: string, name: string } = { origin1: 'cd236732-1767-4b39-8a05-42d0e6d4b42d', name: 'Administración' }
  loading: boolean = false;
  loadingData: boolean = false;

  documentNameValid: boolean = true;

  defaultData: any;

  /* ------------- */
  a3docName: string = '';
  a3docMimeType: string = '';
  a3docData: string = '';
  a3docCreatedAt: Date;
  a3docCategory: [];
  a3docCompany: { identifier: string, nif: string, name: string, companyCode: string } = { identifier: null, nif: null, name: null, companyCode: null }
  a3docB64file: string;
  a3docUsersSelected: string;
  a3docReaders: {} = {};

  constructor(
    _route: ActivatedRoute,
    _modelService: AppDocumentosService,
    _messageDialog: MessageDialog,
    protected _session: SessionHelper,
    _router: Router,
    _location: Location,
    protected userService: AppUsuarioService,
    protected appA3DocDocumentModel: AppA3DocDocument,
    private appA3DocService: AppA3DocService,
    private _livesSession: LivesSessionHelper,

  ) {
    super(_modelService, _messageDialog, _route, _router, _location, AppA3DocDocument);
    this.getModel();
    this.model = new AppA3DocDocument();
    this.isNew = this.checkIsNew();
  }


  ngOnInit(): void {
    const navigationData = history.state.data || JSON.parse(this._livesSession.DocumentData);

    if (!this.isNew) {

      this.loadingData = true;

      // this._modelService.getAllModels().subscribe(allModels => {
      const documentFound = navigationData;

      if (documentFound.id) {
        this._livesSession.DocumentData = JSON.stringify(documentFound)
        this.sendButton = 'Actualizar';
        this.appA3DocDocumentModel.id = documentFound.id;
        this.appA3DocDocumentModel.title = documentFound.title;
        this.appA3DocDocumentModel.customerName = documentFound.customerName;
        this.appA3DocDocumentModel.customerId = documentFound.customerId;
        this.appA3DocDocumentModel.date = new Date(documentFound.date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', });
        this.appA3DocDocumentModel.containersId = documentFound.containersId;
        this.appA3DocDocumentModel.containersNames = documentFound.containersNames;
        this.appA3DocDocumentModel.isAppDoc = documentFound.isAppDoc;
        this.appA3DocDocumentModel.attributes = documentFound.attributes;
        this.appA3DocService.getDoc(documentFound.id)
          .then(result => {
            this.appA3DocDocumentModel.docData = result.content;
            this.appA3DocDocumentModel.type = documentFound.type;
          })
          .catch(error => {
            console.error('Error al obtener documento', error);
          });


        //Modelo por defecto para el patch
        this.defaultData = {
          a3docId: documentFound.id,
          a3docName: documentFound.title,
          a3docData: documentFound.docData,
          a3docMimeType: documentFound.mimeType,
          a3docCategory: documentFound.containersId,
          a3docCompany: documentFound.customerName,
        }

        this.a3docUsersSelected = documentFound.attributes
          .filter(attr => attr.id === '802')
          .map(attr => attr.value);

        this.appA3DocService.getDocumentReaders({ document: this.appA3DocDocumentModel.id })
          .then(result => {
            this.a3docReaders = result
          })
          .catch(error => {
            console.error('Error al obtener documento', error);
          })

      } else {

        this._messageDialog.ShowAlert(
          'Error al encontrar el documento',
          'El documento seleccionado no se encuentra'
        );
      }




      this.loadingData = false;


    } else {
      this._livesSession.removeDocumentData();
      this.a3docName = null;
      this.a3docCreatedAt = null;
      this.a3docCategory = null;
      this.a3docCompany = { identifier: null, nif: null, name: null, companyCode: null };
    }
  }

  setDocumentName(newValue: string): void {
    this.a3docName = newValue;
    this.appA3DocDocumentModel.title = newValue;
    this.documentNameValid = /^(?!\s*$).+/.test(newValue);
  }


  setCreatedAt(newValue: Date): void {
    this.a3docCreatedAt = newValue;
  }

  setMimeType(newValue: string): void {
    this.a3docMimeType = newValue;
    this.appA3DocDocumentModel.type = newValue;
  }


  /* ////////////////////////////////  LOCAL /////////////// */
  /* setCategory(category: string) {
    if (category !== 'undefined') {
      this.model.category.docCategory1 = category;
    }
   
  } */

  setCategory(category: any) {
    if (category.length > 0) {
      this.a3docCategory = category
      this.appA3DocDocumentModel.containersId = category.map(category => category.id);
    }

  }

  companySelectedChanged(data: any) {

    if (data && data[0]) {
      this.a3docCompany.name = data[0].name;
      this.a3docCompany.nif = data[0].nif;
      this.a3docCompany.companyCode = data[0].companyCode;
      this.a3docCompany.identifier = data[0].id;
    } else {
      console.warn('Data is null or undefined:', data);
    }
  }

  setDocData(newValue: string) {
    this.a3docData = newValue;
    this.appA3DocDocumentModel.docData = newValue;
  }



  onFileSelected(event) {
    const file: File = event.target.files[0];

    if (file) {
      if (file.type !== 'application/pdf') {
        this._messageDialog.ShowAlert(
          'Error al subir documento',
          'Solo se pueden subir documentos .pdf'
        );
        return;
      }
    }

    // Comprobar el tamaño del archivo (10 MB = 10 * 1024 * 1024 bytes)
    if (file.size > 10 * 1024 * 1024) {
      this._messageDialog.ShowAlert(
        'Error al subir documento',
        'El documentos no puede superar los 10 MB'
      );
      return;
    }


    // Convertir el archivo a Base64
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const base64Data = e.target.result.split(',')[1];
      this.documentData = `data:${file.type};base64,${base64Data}`;
      this.a3docData = base64Data;

      // Guardar datos
      this.setDocumentName(file.name);
      this.setDocData(this.a3docData);
      this.setCreatedAt(new Date())
      this.setMimeType(file.type);
    };
    reader.readAsDataURL(file);
  }



  onFileOpen() {
    let base64: string;

    if (this.documentData) {
      base64 = this.documentData.split('base64,')[1];
    } else if (this.appA3DocDocumentModel.docData) {
      base64 = this.appA3DocDocumentModel.docData;
    } else {
      base64 = this.a3docData;
    }
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }


  getFormattedDate(dateData: Date): string {
    const date = new Date(dateData);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son de 0-11 en JavaScript
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  checkIsNew(): boolean {
    if (this._router.url.endsWith('new')) {
      return true
    } else {
      return false;
    }
  }

  dataIsFilled(data: any) {
    // Verifica las propiedades principales de 'data'
    for (const prop in data) {
      if (data[prop] === null || data[prop] === undefined || data[prop] === '') {
        return false;
      }
    }

    // Verifica las propiedades dentro de 'data.company'
    if (data.company) {
      for (const prop in data.company) {
        if (data.company[prop] === null || data.company[prop] === undefined) {
          return false;
        }
      }
    }

    return true;
  }

  onPublishClick() {
    this.loading = true

    const sendData =
    {
      "name": this.a3docName,
      "docData": this.a3docData,
      "mimeType": this.a3docMimeType,
      "category": this.a3docCategory,
      "company": this.a3docCompany,
    }

    if (!this.isNew) {

      this.appA3DocService.updateDoc(this.appA3DocDocumentModel).then(
        (response) => {
          if (response.errorCode === 0) {
            this._messageDialog.ShowMessage(

              'Se ha actualizado el documento correctamente',
              'Documento actualizado'
            );
            const documentData = JSON.parse(this._livesSession.DocumentData || '{}');
            documentData.title = this.appA3DocDocumentModel.title;
            documentData.containersId = this.appA3DocDocumentModel.containersId;
            this._livesSession.DocumentData= JSON.stringify(documentData);
            this.loading = false;
          } else {
            // Manejo del error cuando errorCode no es 0
            this._messageDialog.ShowAlert(
              'Ocurrió un error al actualizar el documento',
              'Error al actualizar documento'
            );
            console.error('Error al actualizar documento', response);
            this.loading = false;
          }
        },
        (error) => {
          // Manejo del error en caso de fallo de la promesa
          this._messageDialog.ShowAlert(
            'Ocurrió un error al actualizar el documento',
            'Error al actualizar documento'
          );
          console.error('Error al actualizar documento', error);
          this.loading = false;
        }
      );


    } else {
      if (this.dataIsFilled(sendData)) {

        this.appA3DocService.createDoc(sendData)
          .then(result => {
            const id = result.documentId;

            this._messageDialog.ShowContinueMessage(
              'Documento publicado',
              'Se ha publicado el documento correctamente'
            ).
              then(() => {
                this._router.navigate(['/home', 'app', 'app-docs', 'app-documents']);
              });
            this.loading = false
          })
          .catch(error => {
            this._messageDialog.ShowAlert(
              'Ocurrió un error al publicar el documento',
              'Error al publicar documento',
            );
            this.loading = false
            console.error('Error al crear documento', error)
          });
      }
      else {
        this._messageDialog.ShowAlert(
          'Faltan datos obligatorios para generar el documento',
          'Error al publicar documento'
        );
        this.loading = false
      }
    }

  }

  onUsersSelectedChange(users: any): void {
    this.appA3DocService.updateDocUsers(this.appA3DocDocumentModel, users, true, false).then(
      (response) => {
        if (response.response.errorCode === 0) {
          this._messageDialog.ShowMessage(
            'Documento actualizado',
            'Se ha actualizado el documento correctamente'
          );

          this.updateDocumentDataInSession(response.attributes);
          this.a3docUsersSelected = users.map(user => user.nif).join(', ');
          this.loading = false;

        } else {
          // Manejo del error cuando errorCode no es 0
          this._messageDialog.ShowAlert(
            'Ocurrió un error al actualizar el documento',
            'Error al actualizar documento'
          );
          console.error('Error al actualizar documento', response);
          this.loading = false;
        }
      },
      (error) => {
        // Manejo del error en caso de fallo de la promesa
        this._messageDialog.ShowAlert(
          'Ocurrió un error al actualizar el documento',
          'Error al actualizar documento'
        );
        console.error('Error al actualizar documento', error);
        this.loading = false;
      }
    );
  }


  onDeleteUser(user: any): void {
    let usersSelectedInfo;

    this.userService.getAllForSelectByCompanyNif(this.appA3DocDocumentModel.customerId).subscribe(
      data => {
        if (data.length > 0) {
          usersSelectedInfo = data.filter(user => this.a3docUsersSelected.includes(user.nif));
        }

        // Ejecutar la segunda consulta después de que la primera se haya completado
        this.appA3DocService.deleteDocUsers(this.appA3DocDocumentModel, user, usersSelectedInfo).then(
          (response) => {
            if (response.response.errorCode === 0) {
              this._messageDialog.ShowMessage(
                'Documento actualizado',
                'Se ha actualizado el documento correctamente'
              );

              this.updateDocumentDataInSession(response.attributes);

              const filteredUserNifs = usersSelectedInfo
                .filter(userSelected => userSelected.nif !== user.nif)
                .map(userSelected => userSelected.nif)
                .join(', ');

              this.a3docUsersSelected = filteredUserNifs;

              this.loading = false;

            } else {
              // Manejo del error cuando errorCode no es 0
              this._messageDialog.ShowAlert(
                'Ocurrió un error al actualizar el documento',
                'Error al actualizar documento'
              );
              console.error('Error al actualizar documento', response);
              this.loading = false;
            }
          },
          (error) => {
            // Manejo del error en caso de fallo de la promesa
            this._messageDialog.ShowAlert(
              'Ocurrió un error al actualizar el documento',
              'Error al actualizar documento'
            );
            console.error('Error al actualizar documento', error);
            this.loading = false;
          }
        );
      },
      error => {
        console.error('error al obtener usuarios por empresa:', error);
      }
    );
  }

  updateDocumentDataInSession(attributes: any[]): void {
    // Convertir todas las claves a minúsculas en attributes y attributeValues
    const convertKeysToLowercase = (items: any[]) =>
      items.map(item => {
        return Object.keys(item).reduce((acc, key) => {
          acc[key.toLowerCase()] = item[key];
          return acc;
        }, {} as any);
      });

    // Obtener el documentData actual de session
    const documentData = JSON.parse(this._livesSession.DocumentData || '{}');

    // Actualizar las propiedades de documentData con claves en minúsculas
    documentData.attributes = convertKeysToLowercase(attributes);

    // Guardar el documentData actualizado en session
    this._livesSession.DocumentData = JSON.stringify(documentData);

  }



  getUrlId(): string {
    var url = this._router.url.split('/');
    return url[url.length - 1]
  }


  afterModelLoad(): void {
  }

  afterModelUpdated(): void {
  }

  getModelInstance(): AppDocumentos {
    return new AppDocumentos();
  }

  afterModelCreated(success: boolean): void {
  }

}